import React from 'react';

import ResyncSection from './ResyncSection';

const ResyncSectionContainer = ({
  fileMetadataLoading,
  fileName,
  filePageName,
  haveToken,
  ...props
}: {
  fileMetadataLoading: boolean;
  fileName: string | null;
  filePageName: string | null;
  haveToken: boolean;
  loading: boolean;
  readOnly: boolean;
  onResyncClick: () => void;
}) => (
  <ResyncSection
    {...props}
    initLoading={fileMetadataLoading}
    haveToken={haveToken}
    fileName={fileName}
    filePageName={filePageName}
  />
);

export default React.memo(ResyncSectionContainer) as any;
